var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 } from 'uuid';
/**
 * B64File
 * Classe permettant l'envoi de fichiers et
 * leur gestion sur le serveur.
 */
export class B64File {
    constructor(row) {
        this.uid = v4();
        if (row) {
            const { namespace, name, idFile, data, rotation } = row;
            this.namespace = namespace !== null && namespace !== void 0 ? namespace : null;
            this.name = name !== null && name !== void 0 ? name : null;
            this.data = data;
            this.idFile = idFile;
            this.rotation = rotation !== null && rotation !== void 0 ? rotation : 0;
        }
    }
    static dataURLtoFile(dataurl, filename) {
        const array = dataurl.split(',');
        const mime = array[0].match(/:(.*?);/)[1];
        const bstr = atob(array[1]);
        let n = bstr.length;
        const u8array = new Uint8Array(n);
        while (n > 0) {
            u8array[n] = bstr.codePointAt(n);
            n -= 1;
        }
        return new File([u8array], filename, {
            type: mime,
        });
    }
    static pathUrlToFile(url) {
        const namespace = url.slice(8, url.lastIndexOf('/'));
        let name = url.slice(Math.max(0, url.lastIndexOf('/') + 1));
        name = name.slice(Math.max(0, name.indexOf('_') + 1));
        let idFile = url.slice(Math.max(0, url.lastIndexOf('/') + 1));
        idFile = idFile.slice(0, Math.max(0, idFile.indexOf('_')));
        return new B64File({
            idFile,
            namespace,
            name,
            data: null,
        });
    }
    /**
     * Converti un fichier en `B64File`
     * @param file Fichier à convertir
     * @param rotation Rotation à appliquer
     * @return Fichier converti
     */
    static fromFormFile(file, rotation) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.addEventListener('load', () => {
                    resolve(new B64File({
                        name: file.name,
                        data: reader.result.toString(),
                        namespace: '',
                        idFile: '',
                        rotation,
                    }));
                });
                reader.readAsDataURL(file);
            });
        });
    }
    hasData() {
        return !!this.data;
    }
    getSrc() {
        if (this.data && this.data != null) {
            return this.data;
        }
        if (this.idFile) {
            return `/uploads/${this.namespace}/${this.idFile}_${this.name}`;
        }
        return '';
    }
    toRaw() {
        var _a;
        return {
            idFile: this.idFile,
            namespace: this.namespace,
            name: this.name,
            data: this.data,
            rotation: (_a = this.rotation) !== null && _a !== void 0 ? _a : 0,
        };
    }
    getFileTypeFromName() {
        const typeRegex = /.+\.([^.]+)$/g;
        return this.name.replaceAll(typeRegex, '$1');
    }
    getAsFile() {
        if (this.data) {
            return B64File.dataURLtoFile(this.data, this.name);
        }
        return new File([], this.name);
    }
    /**
     * Oriente le fichier au degré voulu
     * @param rotation Degré de rotation
     * @return Le fichier retourné
     */
    rotateFile(rotation) {
        return new B64File(Object.assign(Object.assign({}, this), { rotation: this.rotation + rotation }));
    }
    /**
     * Enlève le cache d'une image en ajoutant à la fin du nom des nombres aléatoires compris entre 0 et 100
     * @return L'image sans cache
     */
    noCache() {
        return new B64File(Object.assign(Object.assign({}, this), { name: `${this.name}?noCache=${Math.floor(Math.random() * 100)}` }));
    }
}
//# sourceMappingURL=data:application/json;base64,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